{
  "Clear search": "Ryd søgning"
}
